// extracted by mini-css-extract-plugin
export default {"page-title":"search_page-title__56lLH","wrapper":"search_wrapper__0hCDD","results":"search_results__pLYQY"};